<template lang="pug">
  .container
    .roll-order-infos(ref="rollOrder")
      div(v-for="item in rollPool") {{item}} 1分钟前办理
    .header
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/janvideoflow-header.jpg?x-oss-process=style/414_jpeg_zoom")
    .mobile-form
      el-form.form-content
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入陕西移动手机号")
        el-form-item
          el-row.verify-controls
            el-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="6")
            el-button(:disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后可重试
        el-form-item.submit-btn
           img(src="../../../public/images/shaanxi/janvideoflow-button.png", @click="handleSubmit")
    .show-more(v-if="!isShowMore", @click="isShowMore = true")
      .inner-arrow
    div(v-else)
      //- .img-desc
      //-   img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/janvideoflow-price.png?x-oss-process=style/414_jpeg_zoom")
      .notice
        .title ········活动说明········
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content {{notice}}
      el-dialog(
        width="80%",
        title="提示",
        :visible.sync="dialogVisible",
        :before-close="handleClose"
      )
        .dialog-content
          div
            | 您要为手机号：
            span.mobile-info {{form.mobile}}
          div
            | 办理业务：
            span.package-info {{selectedPackage.name}}
        span.dialog-footer(slot="footer")
          el-button(@click="dialogVisible = false") 取消
          el-button(type="primary", @click="handleSubmit") 确定
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      rollPool: ['136****3827', '137****1974'],
      shareNoticeVisiable: false,
      showMoreNotice: false,
      dialogVisible: false,
      isShowMore: true,
      leftSendTime: 0,
      channel: 'TUIA',
      rollOrderTop: 0.5,
      form: {
        carrierId: 1,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null
      },
      notices: [
        '资费说明：本活动仅限陕西移动用户参加，需话费支付30元，包含30GB国内通用流量，2个热门视频APP周卡会员权益（周会员权益领取成功后有效期7天），流量包及会员权益领取有效期10天。',
        '生效时间：本包30元30GB金牛贺岁包（权益版）订购后一次性收取费用，办理后立即生效，到期自动失效，生效后不可退订，可叠加办理。',
        '流量包使用优先级同传统假日流量包，高于套内流量，低于小时包、日包。流量不可结转、不可共享，订购关系到期自动失效。',
        '热门视频APP包含爱奇艺、优酷、腾讯、PP视频、芒果TV、搜狐会员权益，客户需在流量包生效后有效期内自行点击链接领取，过期领取将自动失效。权益领取链接：https://dx.10086.cn/shipin。',
        '赠送咪咕钻石会员权益将由系统自动关联开通平台业务，无需领取，有效期至办理当月月底。',
        '扣费方式：该产品需要扣除话费办理，办理之前话费余额需要大于办理套餐的费用；该业务办理成功后不能抵扣之前超出的流量。',
        '温馨提示：办理本业务时，请确认手机号码和短信验证码输入正确。'
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'TUIA20210122001'
        }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
    setTimeout(() => {
      this.rollOrder()
    }, 2000)
  },
  methods: {
    rollOrder() {
      if (this.rollOrderTop < 1.2) {
        this.$refs.rollOrder.querySelector('div').style.marginTop = `-${this.rollOrderTop}rem`
        setTimeout(() => {
          this.rollOrderTop += 0.2
          this.rollOrder()
        }, 80)
      } else {
        let _numPrefix = [138, 137, 136]
        let _num = 9999 - Math.floor(Math.random() * 8999)
        this.rollPool.push(`${_numPrefix[Math.floor(Math.random() * 3)]}****${_num}`)
        this.$refs.rollOrder.querySelector('div').style.marginTop = '0.5rem'
        this.rollPool.splice(0, 1)
        this.rollOrderTop = 0.5
        setTimeout(() => {
          this.rollOrder()
        }, 2000)
      }
    },
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      this.dialogVisible = true
    },
    checkMobile() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'videoflowbagSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background-color: #FA5038;
  padding-bottom: 3.5rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
.mobile-form{
  margin: 0 1rem;
  padding: .8rem;
  img{
    width: 100%;
    border-radius: 12px;
  }
  .form-content{
    width: 90%;
    margin: 1rem auto;
    .el-form-item{
      margin-top: 1rem;
    }
    input{
      border-radius: 6px;
      font-size: 1rem;
    }
  }
  @keyframes buttonheartbeat{
    0%{
      transform: scale3d(1,1,1);
    }
    20%{
      transform: scale3d(1.03,1.03,1.03);;
    }
    40%{
      transform: scale3d(.9,.9,.9);
    }
    60%{
      transform: scale3d(1.03,1.03,1.03);
    }
    80%{
      transform: scale3d(1.03,1.03,1.03);
    }
    100%{
      transform: scale3d(.97,.97,.97);
    }
  }
  .submit-btn{
    margin: 0 auto;
    margin-top: 1rem;
    height: 2.9rem;
    img{
      animation: buttonheartbeat 5s infinite;
    }
    button{
      width: 100%;
      font-size: 1.3rem;
      font-weight: bold;
      border-radius: 36px;
      background: linear-gradient(rgb(224, 101, 234), rgb(159, 41, 224));
      border: 0;
    }
  }
}
.packages-form{
  .packages-info{
    >ul{
      display: flex;
      >li{
        flex: 1;
        font-size: .8rem;
        font-weight: bold;
        background-color: #f5f3f3;
        margin: .4rem;
        border-radius: 12px;
        >div{
          margin: .8rem .2rem;
        }
        .name{
          color: #e69a79;
        }
        .desc{
          color: #888;
        }
        &.selected{
          background-color: #88f3d1;
          .name{
            color: #e75e25;
          }
          .desc{
            color: #333;
          }
        }
      }
    }
    .tips{
      margin: 6px;
      font-size: .8rem;
      text-align: left;
      .tip{
        margin: 3px 0;
        i{
          color: #48c89f;
        }
      }
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.img-desc{
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  img{
    width: 100%;
  }
}
.notice{
  padding-top: 4rem;
  color: #fff;
  .title{
    font-size: 1.4rem;
    text-align: center;
  }
  ul{
    width: 90%;
    margin: 0 auto;
    font-size: .8rem;
    padding: 1rem;
    li{
      clear: both;
      overflow: hidden;
      
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
.verify-controls{
  .el-input{
    width: 60%;
    input{
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      height: 40px;
      line-height: 40px;
      vertical-align: top;
    }
  }
  button{
    width: 40%;
    padding:0;
    height: 40px;
    line-height: 40px;
    border: 0;
    border-radius: 0;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    vertical-align: top;
  }
}
@keyframes fly{
   from{
     margin-top: 2rem;
     margin-bottom: 2rem;
   }
   to{
     margin-top: 3rem;
     margin-bottom: 1rem;
   }
 }
.show-more{
  width: 2rem;
  height: 2rem;
  margin: 2rem auto;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
  position: relative;
  transform: rotate(45deg);
  animation: fly .5s infinite alternate;
  .inner-arrow{
    position: absolute;
    width: 2rem;
    height: 2rem;
    margin-left: -.5rem; 
    margin-top: -.5rem;
    border-bottom: 1px solid #fff;
    border-right: 1px solid #fff;
  }
}
.roll-order-infos{
  position: fixed;
  right: 0;
  top: 0;
  background-color: rgba(33, 33, 33, .6);
  color: #f3f3f3;
  font-size: .8rem;
  height: 2rem;
  overflow: hidden;
  padding: 0 1rem;
  width: 10rem;
  text-align: center;
  >div{
    margin: .5rem 0;
  }
  z-index: 1;
}
</style>